// extracted by mini-css-extract-plugin
module.exports = {"somethingWentWrongPage":"SomethingWentWrong_somethingWentWrongPage__ZR9VY","header":"SomethingWentWrong_header__kNJW8","text":"SomethingWentWrong_text__ophPd"};